import { jsx as _jsx } from "preact/jsx-runtime";
export default function FinderStatus({ count, mode }) {
    return (_jsx("strong", Object.assign({ "aria-live": "polite", role: "status", className: `finder-status ${count === 0 ? 'finder-status--no-result' : ''}` }, { children: getStatusMessage(count, mode) }), void 0));
}
function getStatusMessage(count, mode) {
    if (mode === 'project') {
        switch (count) {
            case 0:
                return `Keine passendes Projekt gefunden`;
            case 1:
                return `Ein Projekt gefunden`;
            default:
                return `${count} Projekte gefunden`;
        }
    }
    if (mode === 'location') {
        switch (count) {
            case 0:
                return `Kein passender Standort gefunden`;
            case 1:
                return `Ein Standort gefunden`;
            default:
                return `${count} Standorte gefunden`;
        }
    }
    return '';
}
